import React from "react";
import "./styles.scss";
import Button from "../../../common/button";
import { useNavigate } from "react-router-dom";

const HCPMissionSection = (props) => {
  const { button_text, description, title } = props;
  const Navigate = useNavigate();
  return (
    <div className="hcp-mission-container">
      <div className="section">
        <h3>{title}</h3>
        <p dangerouslySetInnerHTML={{ __html: description }} />
        <Button
          onClick={() => Navigate(`${process.env.REACT_APP_BASE}/risk-fall`)}
        >
          {button_text}
        </Button>
      </div>
    </div>
  );
};

export default HCPMissionSection;
